import type { BetbyRendererInstance } from '@/types/betby';

import { routes } from '@/features/v2/constants/routes';

let betbyRenderer: BetbyRendererInstance | null = null;

export const setBetbyRenderer = (renderer: BetbyRendererInstance | null): void => {
  betbyRenderer = renderer;
};

export const isSportsbookPath = (pathname: string | null | undefined): boolean => {
  if (!pathname) {
    return false;
  }

  return pathname === routes.SPORTS || pathname.startsWith(`${routes.SPORTS}/`);
};

/** Redirect Betby to its home without kill/init. Returns true when handled. */
export const navigateBetbyHome = (): boolean => {
  if (!betbyRenderer) {
    return false;
  }

  betbyRenderer.updateOptions({ url: '/' });

  if (window.location.pathname !== routes.SPORTS) {
    window.history.replaceState(window.history.state, '', routes.SPORTS);
  }

  return true;
};
